import { DateTime } from 'luxon';
import { useInterval } from '../../../../hooks/useInterval/useInterval';
import { getTimeDurationString } from '@amzn/atoz-shiftapp-utilities';
export var useCountDownMessage = function (dropDeadline) {
    return useInterval({
        fn: function () {
            return getTimeDurationString(dropDeadline, DateTime.utc());
        }
    });
};
